import { objectsRHandler } from '@/utils/objectsRHandler';

import EventTemplate from '../list/event-template';

const API_PATH = 'event-templates';

export const EventTemplatesManager = {
  objects: objectsRHandler(API_PATH, EventTemplate),
};
